
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Medical History Component
 * @param response has the backend
 * Medical History component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result :any = {
        getidentifier:[],
        error:undefined
    }

    const { log, settings:{epicendpoints} } = context;
    let responsearray:any[] = [];
    if (response && response.status >= 400) {
        result.error=response;
     }
    if (response?.length > 0) {
        response.forEach((identifierdata:any)=>{
            if(identifierdata?.Identifiers?.length > 0) {
                identifierdata.Identifiers.forEach((iddata:any)=> {
                    let patientidobj: any = {
                        id: ""
                    };
                    if(iddata?.Type === epicendpoints.searchID) {
                        patientidobj.id = iddata?.ID;
                        responsearray.push(patientidobj)
                    }
                })
            }
        })

        result.getidentifier=responsearray;
    }
    log.debug(
        "ccw-gadget,getsession-epic",
        "getaccessidentifier-epic transformation response ", {
        result
    });
    return result;
}